import { render, staticRenderFns } from "./TodayCardsFacebook.vue?vue&type=template&id=6a0f5894&"
import script from "./TodayCardsFacebook.vue?vue&type=script&lang=js&"
export * from "./TodayCardsFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports